export const isAssetTreeSelected = () => {
    const currentUrl = new URL(window.location.href);
    return currentUrl.searchParams.get('is_asset_tree_selected') === 'true';
};
